/**
 * Enumerator for all basket time types
 * @export
 * @enum BasketTimeTypes
 */
export enum BasketTimeTypes {
    Asap = 'Asap',
    Time = 'Time',
    Future = 'Future'
  }
